import { PermissionClient } from '@backstage/plugin-permission-common';

class IdentityPermissionApi {
  constructor(permissionClient, identityApi) {
    this.permissionClient = permissionClient;
    this.identityApi = identityApi;
  }
  static create(options) {
    const { config, discovery, identity } = options;
    const permissionClient = new PermissionClient({ discovery, config });
    return new IdentityPermissionApi(permissionClient, identity);
  }
  async authorize(request) {
    const response = await this.permissionClient.authorize(
      [request],
      await this.identityApi.getCredentials()
    );
    return response[0];
  }
}

export { IdentityPermissionApi };
//# sourceMappingURL=IdentityPermissionApi.esm.js.map
